import axios from '@axios'
import _ from 'lodash'

export default function store(formConfig) {
    let urlEntity = _.snakeCase(formConfig.entity)
    let res = {
        namespaced: true,
        state: {},
        getters: {},
        mutations: {},
        actions: {},
    }
    res.actions[`search${formConfig.entity}`] = function (ctx, {
        page_no = 1,
        page_size = 10,
        order_by = 'id',
        order = 'asc',
        filter = undefined
    }) {
        let param = "";
        if (filter != null) {
            param = `page_no=${page_no}&page_size=${page_size}&order_by=${_.camelCase(order_by)}&order=${order}&filter=${filter}`
        } else {
            param = `page_no=${page_no}&page_size=${page_size}&order_by=${_.camelCase(order_by)}&order=${order}`
        }
        return new Promise((resolve, reject) => {
            axios.get(`/${urlEntity}?${param}`)
                .then(response => resolve(formConfig.resolve(response)))
                .catch(error => reject(error))
        })
    }
    res.actions[`get${formConfig.entity}`] = function (ctx, {
        id = 1,
    }) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/${urlEntity}/${id}`)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    }
    res.actions[`update${formConfig.entity}`] = function (ctx, {
        id = 1,
        body
    }) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/${urlEntity}/${id}`, body)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    }
    res.actions[`create${formConfig.entity}`] = function (ctx, {
        body
    }) {
        return new Promise((resolve, reject) => {
            axios
                .post(`/${urlEntity}`, body)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    }
    console.log(res);
    return res;
}


